(function () {
  class ReelFireball extends PIXI.Container {
    constructor() {
      super();

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
    }

    findChild(parent, name) {
      const child = parent.find(function (child) {
        return child.Props.ID === name;
      });
      return child;
    }

    onGameConfigEvent() {
      this._fireball = this.findChild(this.children[0].children, "fireball");
      this._fireball.gotoAndStop(0);
      this._fireball.visible = false;
      this._blueFireball = this.findChild(
        this.children[0].children,
        "bluefireball"
      );
      this._blueFireball.gotoAndStop(0);
      this._blueFireball.visible = false;
    }

    animate(isWildFire, task, callback) {
      const fireball = isWildFire ? this._blueFireball : this._fireball;
      fireball.visible = true;
      fireball.gotoAndPlay(0);

      timerManager.addTimer(
        100,
        function () {},
        function () {
          task();
        }
      );

      const self = this;
      timerManager.addTimer(
        500,
        function (progress) {
          const startPos = layoutController.getCurrentPosition(self.Props.FQN);
          const endPos = layoutController.getCurrentPosition(
            "slotContainer:reelFireballs:endPos"
          );

          const xDist = (endPos.x - startPos.x) * progress;
          const yDist = (endPos.y - startPos.y) * progress;

          self.position.set(startPos.x + xDist, startPos.y + yDist);

          const revProg = 1 - progress;
          const scale = 0.3 + 0.7 * revProg;
          fireball.scale.set(scale, scale);
        },
        function () {
          const endPos = layoutController.getCurrentPosition(
            "slotContainer:reelFireballs:endPos"
          );
          self.position.set(endPos.x, endPos.y);
          fireball.scale.set(0.3, 0.3);
          timerManager.addTimer(
            100,
            function (progress) {
              fireball.alpha = 1 - progress;
            },
            function () {
              fireball.scale.set(1, 1);
              fireball.alpha = 1;
              fireball.visible = false;
              const startPos = layoutController.getCurrentPosition(
                self.Props.FQN
              );
              self.position.set(startPos.x, startPos.y);

              callback();
            }
          );
        }
      );
    }
  }

  var creator = function (json) {
    return new ReelFireball();
  };

  var initialiser = function (json, reelFireball) {};

  var filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "reelFireball",
    creator,
    initialiser,
    filesRequired
  );
})();
